import React, { Fragment, useState } from 'react';
import Loader from '../../../components/Loader/Loader';
import { Col, Form, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap';
import { createSigner } from '../../../api/workflow';
import { failed, success } from '../../../utils/Tostify';
import { useDispatch, useSelector } from 'react-redux';
import { useFormik } from 'formik';
import { formikAddSigner } from '../Constant';
import TextInput from "../../../components/InputFields/TextInput";

const AddSignerModal = ({refetch, setShowModal}) => {
    let token = useSelector(state => state.userReducer.token);
    const [isLoading, setIsLoading] = useState(false);
    const dispatch = useDispatch();

    const formik = useFormik({
        ...formikAddSigner,
        onSubmit: async (values) => {
            handleSubmit(values);
        }
    });


    const handleSubmit = async(values)=>{
        let res;
        try {
            setIsLoading(true);
            let res = await createSigner({ values, dispatch, token });
            if (res?.status == "SUCCESS") {
                await refetch();
                setIsLoading(false);
                setShowModal();
                success(res?.message);
            }else{
                setShowModal();
                failed(res?.message);
            }
        } catch (error) {
            setIsLoading(false);
            failed(res?.message);
        }
    };

  return (
    <Fragment>
      <Modal isOpen={setShowModal} toggle={()=>{setShowModal();}} size="sm" className='user_modal_block'>
        <ModalHeader toggle={setShowModal} className="assign_blk">{"Add Singer"}</ModalHeader>
        <Form onSubmit={formik.handleSubmit}>
        <ModalBody className="assign_modal_body">
        {isLoading ? <Loader /> : null}
          <div className="organization_form_block organization_blk organization_modal modal_change_color">
            <div className="d-flex gap-4 px-4">
              <div className="forms_block">
              <Row>
                <Col lg={12} className="location_block">
                      <TextInput
                        keyField={"signer"}
                        label="Signer"
                        type="text"
                        value={formik.values.signer}
                        onChange={(e) => formik.setFieldValue("signer", e.target.value)}
                      />
                </Col>
            </Row>
              </div>
            </div>
          </div>
        </ModalBody>
        <ModalFooter className="p-0 mt-3">
          <div className="d-flex justify-content-center gap-5 mb-4">
            <button className="save_btn" onClick={setShowModal}>Close</button>
            <button className="save_btn second" type="submit">Save</button>
          </div>
        </ModalFooter>
        </Form>
      </Modal>
    </Fragment>
  );
};

export default AddSignerModal;
